import { render, staticRenderFns } from "./CustomersReached.vue?vue&type=template&id=1b8fe1cc"
import script from "./CustomersReached.vue?vue&type=script&lang=js"
export * from "./CustomersReached.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports